'use client';

import { useTranslations } from 'next-intl';
import { Plus } from 'lucide-react';
import { Button } from '@/shared/ui/shadcn/button';
import { cn } from '@/shared/lib/cn';

interface DerivativeAnglesHeaderProps {
  isEmpty: boolean;
  onAdd?: () => void;
}

export function DerivativeAnglesHeader({
  isEmpty,
  onAdd,
}: DerivativeAnglesHeaderProps) {
  const t = useTranslations('secondaryViews');

  return (
    <div className="mb-4 flex items-center justify-between">
      <h3
        className={`text-card-title ${
          isEmpty ? 'text-muted-foreground/50' : 'text-foreground'
        }`}
      >
        {t('title')}
      </h3>
      {onAdd && (
        // 44px hit area / 28px visible pill — matches the angle-menu pills
        // (Apple AngleMenuPill parity).
        <Button
          variant="ghost"
          size="icon"
          onClick={onAdd}
          aria-label={t('addButton')}
          className={cn(
            'relative inline-flex h-11 w-11 items-center justify-center bg-transparent hover:bg-transparent',
            "before:absolute before:inset-2 before:rounded-full before:content-['']",
            'before:bg-muted hover:before:bg-muted/80'
          )}
        >
          <Plus className="relative h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
